import Link from 'next/link'

import { Tips } from '../../api/search.api'
import { useCurrentPath } from '../../hooks/use-current-path'

import { ProductsIcon } from './assets/products-icon'

import cl from './style.module.scss'

export interface SearchCatsProps {
	items: Tips[]
	linkSalt?: string
	onClick?: () => void
}

export const SearchProducts = (props: SearchCatsProps) => {
	const { items, onClick = () => {} } = props
	const { withSalt } = useCurrentPath()

	return (
		<div className={cl.cats}>
			<h4 className={cl.title}>Часто ищут</h4>
			{items?.map(item => {
				const url = item.redirect_url || `/catalog/products/${item.request}?${withSalt}`
				return (
					<Link prefetch={false} key={item.request} className={cl.item} href={url} onClick={onClick}>
						<ProductsIcon />
						<p className={cl.label}>{item.request}</p>
					</Link>
				)
			})}
		</div>
	)
}
